<template>
    <div class="member-person member-tab">
        <alart-msg :display="alart.success" styleType="success" @alartStatus="alart.success = false">
            <span class="title" slot="title">{{msg.success}}</span>
        </alart-msg>
        <alart-msg :display="alart.fail" styleType="error" @alartStatus="alart.fail = false">
            <span class="title" slot="title">{{msg.error}}</span>
        </alart-msg>
        <div class="member-person-wrap">
            <div class="detail-group">
                <label for="">電子郵件</label>
                <div class="input-error-group">
                    <input type="text" v-model="email"  placeholder="請輸入電子郵件">
                    <span v-show="error.emailErr" class="error">{{error.emailErr}}</span>
                </div>
            </div>
            <div class="email-description">
                <div class="line1">
                    <img src="@/assets/img/icon/info_gray.svg" alt="">
                    飛豬平台響應支持地球環保，並配合政府節能減碳計畫推
                </div>
                <div class="line2">
                    動，將以 E-MAIL 方式將電子發票寄送至您的電子郵件信箱，請確保E-MAIL 填寫正確。
                </div>
            </div>
            <div class="detail-group">
                <label for="">關於我</label>
                <div class="input-error-group">
                    <textarea v-model="introduction" placeholder="自我介紹一下吧！" />
                    <span v-show="error.introductionErr" class="error">{{error.introductionErr}}</span>
                </div>
            </div>
            <button class="default-button" @click="saveInfo()" >儲存</button>
        </div>
</div>
</template>
<script>
import AlartMsg from '@/components/widge/AlartMsg.vue';
import { mapGetters } from 'vuex'
import { 
    apiSetUserPersonInfo
} from "@/apis/api.js"; 

export default {
    data () {
        return {
            email: '',
            introduction: '',
            error: {
                emailErr: '',
                introductionErr: ''
            },
            alart: {
                success: false,
                fail: false
            },
            msg: {
                success: '',
                error: '',
            }
        }
    },
    mounted () {
        // this.$analytics.logEvent('個資編輯', { screen_name: '個資編輯'})
        this.$store.dispatch('getUserStatus')
    },
    watch: {
        userInfo: {
            handler: function (val) {
                this.email = val.email
                this.introduction = val.introduction
            },
            // immediate: true,
            deep: true
        },
        email: function (val) {
            this.checkEmail()
        },
        introduction: function (val) {
            if( val.length > 1000){
                this.error.introductionErr = '字數限制1000以內'
            }else{
                this.error.introductionErr = ''
            }
        }
    },
    methods: {
        saveInfo: function (){
            this.$analytics.logEvent('送出個資編輯', { screen_name: '送出個資編輯'})
            let data = {
                email: this.email,
                introduction: this.introduction,
            }
            if(this.checkInput()){
                apiSetUserPersonInfo(data)
                .then(res => {
                    console.log(res)
                    if(res.data.status == 'SUCCESS'){
                        this.$store.dispatch('getUserStatus')
                        this.alart.success = true
                        this.msg.success = '儲存成功'
                    }else{
                        this.alart.fail = true
                        this.msg.error = '儲存失敗'
                    }
                })
                .catch(err =>{
                    console.log(err)
                })
            }
            
        },
        checkInput: function () {
            this.checkEmail()
            if(
                this.error.emailErr == '' &&
                this.error.introductionErr == ''
            ){
                return true
            }else{
                return false
            }
        },
        checkEmail: function () {
            var isMail = /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z]+$/;
            if (!isMail.test(this.email)) {
                this.error.emailErr = 'Email格式錯誤';
            }else {
                this.error.emailErr = '';
            }
            if( this.email == ''){
                this.error.emailErr = 'Email不得為空';
            }
        }
    },
    computed: {
        ...mapGetters({
            userInfo: 'GET_USER_INFO',
        })
    },
    components: {
        AlartMsg
    }
}
</script>
<style lang="scss" scoped>
    .member-person{
        min-height: 554px;
        span.error{
            right: 0;
            top: -27px;
            left: unset;
            bottom: unset;
        }
        .member-person-wrap{
            padding: 30px;
            label{
                display: block;
                margin-bottom: 12px;
                font-weight: 500;
            }
            .detail-group{
                width: 384px;
                margin-bottom: 30px;
                .input-error-group{
                    position: relative;
                    input{
                        width: 352px;
                    }
                    >textarea{
                        width: 352px;
                        height: 112px;
                        padding: 16px;
                        resize:none;
                    }
                }   
            }
            .email-description{
                width: 384px;
                margin-top: -23px;
                margin-bottom: 30px;
                color: #676362;
                line-height: 1.5;
                .line1{
                    display: flex;
                    align-items: center;
                    img{
                        margin-right: 2px;
                    }
                }
            }
            .default-button{
                width: 384px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/landlord/houseStatus/memberCenter/MemberPerson.vue